define('companiesDetailView',[
  'module',
  'headerFooterView',
  'companiesDetailHeaderView',
  'companiesDetailBodyView'
], function (
  Module,
  HeaderFooterView,
  HeaderView,
  BodyView
) {
  'use strict';

  Module.exports = HeaderFooterView.extend({
    className: 'companies-detail-view ' + HeaderFooterView.prototype.className,
    childHeaderView: HeaderView,
    childView: BodyView
  });
});

